import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { rem } from 'polished'
import PropTypes from 'prop-types'

const StyledSelect = styled.select(({ theme, hasError, isTouchedAndValid }) => {
  let borderColor = theme.colors.light.darker.hex

  if (hasError) {
    borderColor = theme.colors.error.base.hex
  }
  if (isTouchedAndValid) {
    borderColor = theme.colors.success.base.hex
  }

  return css`
    height: 36px;
    padding: ${theme.spacing.xxs} ${theme.spacing.xs};
    border: 1px solid ${borderColor};
    border-radius: ${theme.radius};
    background-color: white;

    &:invalid {
      box-shadow: none;
    }
  `
})

const StyledMessage = styled.div`
  font-size: ${({ theme }) => rem(theme.fonts.body.xs.size)};
  color: ${({ theme, hasError }) =>
    hasError ? theme.colors.error.base.hex : 'inherit'};
  position: absolute;
`

const StyledSelectWrapper = styled.div`
  position: relative;
`

const Select = ({ options, errorMessage, touched, className, ...props }) => {
  const hasError = Boolean(errorMessage) && Boolean(touched)
  const isTouchedAndValid = !errorMessage && Boolean(touched)

  return (
    <StyledSelectWrapper className={className}>
      <StyledSelect
        hasError={hasError}
        isTouchedAndValid={isTouchedAndValid}
        className={className}
        {...props}
      >
        {options.map(({ displayName, value }) => (
          <option key={displayName} value={value}>
            {displayName}
          </option>
        ))}
      </StyledSelect>
      {hasError && (
        <StyledMessage hasError={hasError}>{errorMessage}</StyledMessage>
      )}
    </StyledSelectWrapper>
  )
}

Select.defaultProps = {
  errorMessage: '',
  touched: false,
  className: '',
}

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      option: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  errorMessage: PropTypes.string,
  touched: PropTypes.bool,
  className: PropTypes.string,
}

export default Select
